import { getCountryCallingCode } from "react-phone-number-input/input"

const postForm = async (data) => {
  const { phone, name, email, message, country } = data
  const phoneQuery = phone.length
    ? `phoneNumber: "+${getCountryCallingCode(country)}${phone}",`
    : ""

  const response = await fetch(process.env.GATSBY_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic  ${process.env.GATSBY_API_BASE_AUTH}`,
    },
    body: JSON.stringify({
      query: `mutation{
            sendContactMessage(data: {${phoneQuery} name:"${name}", email:"${email}", message:"${message}", pageTitle: "${window.location.href}"}) {
              ok
            }
          }`,
      variables: null,
    }),
  })
  const body = await response.json()
  return body
}

export default postForm
